import React__default from 'react';
import classnames from 'classnames';
import { CurrentStepContextProvider } from '../../Context/CurrentStepContext.js';
import { ConfiguratorModal } from '../ConfiguratorModal/ConfiguratorModal.js';
import { ConfiguratorStepContainer } from '../ConfiguratorStep/ConfiguratorStepContainer.js';
import { ConfiguratorFooter } from '../Footer/ConfiguratorFooter.js';
import { ConfiguratorHeaderContainer } from '../Header/ConfiguratorHeaderContainer.js';
import { ConfiguratorMainContainer } from '../Main/ConfiguratorMainContainer.js';

const Configurator = ({ 'data-t': dataT , className , isOpen , preventVerticalScroll ,  })=>/*#__PURE__*/ React__default.createElement(ConfiguratorModal, {
        isOpen: isOpen,
        preventVerticalScroll: preventVerticalScroll
    }, /*#__PURE__*/ React__default.createElement("div", {
        "data-t": dataT,
        className: classnames('configurator', className)
    }, /*#__PURE__*/ React__default.createElement(CurrentStepContextProvider, null, /*#__PURE__*/ React__default.createElement(ConfiguratorHeaderContainer, null), /*#__PURE__*/ React__default.createElement(ConfiguratorMainContainer, {
        className: "configurator__main"
    }, /*#__PURE__*/ React__default.createElement(ConfiguratorStepContainer, null)), /*#__PURE__*/ React__default.createElement(ConfiguratorFooter, null))))
;

export { Configurator };
//# sourceMappingURL=Configurator.js.map
